export const enum TextAreaResize {
  Both = 'Both',
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
  None = 'None',
}
